
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2069-1760.508a9.111 9.111 0 003.672-.747 9.726 9.726 0 005.078-5.075 9.43 9.43 0 000-7.334 9.731 9.731 0 00-5.093-5.086 9.406 9.406 0 00-7.324 0 9.731 9.731 0 00-5.083 5.083 9.4 9.4 0 00.007 7.337 9.758 9.758 0 005.08 5.075 9.087 9.087 0 003.663.747zm0-1.748a7.577 7.577 0 01-3.008-.6 7.725 7.725 0 01-4.121-4.126 7.916 7.916 0 010-6.025 7.755 7.755 0 014.116-4.136 7.542 7.542 0 013-.6 7.591 7.591 0 013.022.6 7.8 7.8 0 014.131 4.136 7.577 7.577 0 01.6 3.008 7.432 7.432 0 01-.6 3.018 7.873 7.873 0 01-1.66 2.466 7.707 7.707 0 01-2.461 1.66 7.626 7.626 0 01-3.019.599zm-2.237-5.586a12.493 12.493 0 001.694 1.426 7.837 7.837 0 001.758.938 3.6 3.6 0 001.655.234 2.286 2.286 0 001.387-.693q.049-.049.088-.093t.078-.093a1.357 1.357 0 00.342-.771.786.786 0 00-.361-.723q-.215-.156-.449-.322t-.522-.366q-.288-.2-.659-.454a1 1 0 00-.7-.234 1.184 1.184 0 00-.6.352l-.361.352a.264.264 0 01-.205.083.391.391 0 01-.205-.063 5.864 5.864 0 01-.615-.444 9.452 9.452 0 01-.762-.688q-.371-.381-.684-.762a5.117 5.117 0 01-.449-.615.464.464 0 01-.063-.186.239.239 0 01.083-.205l.352-.381a1.263 1.263 0 00.361-.615.947.947 0 00-.244-.684l-1.133-1.6a.786.786 0 00-.43-.342.888.888 0 00-.532.029 2.175 2.175 0 00-.591.322l-.069.05q-.029.024-.059.054a2.289 2.289 0 00-.693 1.392 3.649 3.649 0 00.229 1.66 7.585 7.585 0 00.933 1.754 12.659 12.659 0 001.426 1.688z"}})])])
          )
        }
      }
    